"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _OrderDetail = _interopRequireDefault(require("@/components/OrderDetail"));
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _permission = require("@/utils/permission");
var _AuditForm = _interopRequireDefault(require("./AuditForm.vue"));
var _constants = require("@/utils/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'riskOrderReview',
  components: {
    DetailsFrom: _OrderDetail.default,
    MerchantName: _merchantName.default,
    AuditForm: _AuditForm.default
  },
  data: function data() {
    return {
      checkPermi: _permission.checkPermi,
      // 权限判断函数
      riskStatusOptions: _constants.riskStatusOptions,
      // 审核状态
      orderNo: '',
      // 当前点击查看详情的订单号
      tableData: {
        // 订单列表数据
        data: [],
        total: 0
      },
      listLoading: true,
      tableFrom: {
        // 订单列表参数
        page: 1,
        limit: 10,
        searchType: 'all',
        // 用户搜索类型 all-全部 uid-用户ID phone-手机号 nickname-用户昵称
        content: '',
        // 用户搜索
        createTimeLimit: '',
        // 下单时间
        merId: null,
        // 商户名称ID
        orderNo: '',
        // 订单编号
        reviewStatus: '',
        // 审核状态 0-待系统确认 1-审核通过 2-订单拦截 3-已取消
        reviewStatusType: 'wait' // tab审核状态 wait-待审核 audited-已审核
      },
      timeVal: [],
      // 时间选择器数据
      card_select_show: false,
      // 列选择器显示
      checkAll: false,
      // 列显示-全选
      checkedCities: [
      // 列显示-已选
      '订单编号', '商户名称', '用户昵称', '实际支付', '支付方式', '订单状态', '下单时间'],
      columnData: [
      // 列显示-列表
      '订单编号', '商户名称', '用户昵称', '实际支付', '支付方式', '订单状态', '下单时间'],
      isIndeterminate: true,
      // 列显示-半选
      tabList: [
      // 订单审核状态tab
      {
        label: '待审核',
        value: 'wait'
      }, {
        label: '已审核',
        value: 'audited'
      }],
      multipleSelection: [],
      // 选中行
      checkedOrderNos: [],
      // 选中行订单编号
      exportLoading: false // 导出加载
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:order:page:list'])) this.getList();
  },
  methods: {
    // 商户名称选择
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
      this.handleSearchList();
    },
    // 筛选重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.timeVal = [];
      this.tableFrom.searchType = 'all';
      this.tableFrom.page = 1;
      this.handleSearchList();
    },
    // 筛选查询
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 查看详情
    onOrderDetails: function onOrderDetails(id) {
      this.orderNo = id;
      this.$refs.orderDetailRef.getDetail(id);
      this.$refs.orderDetailRef.getOrderInvoiceList(id);
      this.$refs.orderDetailRef.dialogVisible = true;
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.createTimeLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _order.getRiskOrderListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total;
        _this.listLoading = false;
        _this.checkedCities = _this.$cache.local.has('order_stroge') ? _this.$cache.local.getJSON('order_stroge') : _this.checkedCities;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    // 分页
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 导出
    exports: function exports() {
      var _this2 = this;
      this.exportLoading = true;
      (0, _order.riskOrderExportExcelApi)(this.tableFrom).then(function (res) {
        window.open(res.fileName);
      }).finally(function () {
        _this2.exportLoading = false;
      });
    },
    // 操作-列显示
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    // 列显示-全选
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    // 列显示-单个切换
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    // 列显示-保存
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    // 勾选行
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      var data = [];
      this.multipleSelection.map(function (item) {
        data.push(item.orderNo);
      });
      this.checkedOrderNos = data;
    },
    // 批量审核
    onBatchAudit: function onBatchAudit() {
      if (!this.checkedOrderNos.length) {
        this.$message.warning('请选择要审核的订单');
        return;
      }
      this.$refs.auditFormRef.open(this.checkedOrderNos);
    },
    // 审核
    onAudit: function onAudit(orderNo) {
      this.$refs.auditFormRef.open([orderNo]);
    }
  }
};